<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Logs de Job
        </p>
      </div>
    </div>
    <div class="q-px-lg q-py-md q-mt-lg">
      <q-timeline v-if="listaLogs.length > 0" color="primary">
        <div
          style="font-size: 20px"
          class="text-brand-5 text-weight-bold q-mb-lg"
        >
          Histórico de Logs
        </div>

        <q-timeline-entry
          class="text-weight-bold text-brand-5 text-weight-bold"
          v-for="(evento, index) in listaLogs"
          :key="index"
          :title="evento.eventoNamespace"
          :subtitle="`Data de Processamento: ${gerarData(
            evento.dataProcessamento
              .split(' ')[0]
              .split('-')
              .reverse()
              .join('/'),
            evento.dataProcessamento.split(' ')[1]
          )}`"
          icon="edit"
        >
          <div style="font-size: 16px">
            {{ evento.mensagem }}
          </div>
        </q-timeline-entry>
      </q-timeline>
      <div
        v-else
        style="font-size: 20px"
        class="text-brand-5 text-weight-bold q-mb-lg q-mt-lg"
      >
        Nenhum Log Registrado
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();
    const listaLogs = ref([]);

    const listarLogJob = async () => {
      try {
        const response = await store.dispatch("office/listarLogsJob");
        listaLogs.value = response.data.resultado.Mensagem;
      } catch (error) {
        console.log(error);
      }
    };

    const gerarData = (data, hora) => {
      const mes = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];
      const dataPartes = data.split("/");
      const dia = parseInt(dataPartes[0], 10);
      const mesIndex = parseInt(dataPartes[1], 10) - 1;
      const year = parseInt(dataPartes[2], 10);

      const monthName = mes[mesIndex];

      return `${dia} de ${monthName} de ${year} - ${hora}`;
    };

    onMounted(listarLogJob);

    return { gerarData, listarLogJob, listaLogs };
  },
};
</script>

<style scoped>
.text-heading {
  font-size: 10px !important;
}
</style>
